
function SearchAdminName({ title, text }) {
    return (
        <div className="flex flex-row-reverse items-center mb-4">
            <p className="w-28 text-right">{title}</p>
            <p className="w-96 p-2 rounded bg-white text-right border border-slate-200 text-slate-500">{text}</p>
        </div>
    )
}
export default SearchAdminName;